import _ from 'lodash';


const analyticsTypes = {
  BUNDLE_INCENTIVE_SHOW: 'incentives_Bundle_Incentive_Show',
  BUNDLE_INCENTIVE_CLAIM: 'incentives_Bundle_Incentive_Claim',
  BUNDLE_INCENTIVE_BULK_ADD: 'incentives_Bundle_Incentive_BulkClaim',
  BUNDLE_INCENTIVE_CLOSE: 'incentives_Bundle_Incentive_Close',
};

const extractBundleAndSaveDetails = (supply, extra) => ({
  version: _.get(extra, 'version', 1),
  supply_item_id: _.get(supply, 'item_id'),
  supply_id: _.get(supply, 'id'),
  supply_price: _.get(supply, 'price', 0) / 100,
  ...extra
});

const extractBundleAndSaveClaim = (parentSupply, supply, extra) => ({
  ...extractBundleAndSaveDetails(supply, extra),
  parent_item_id: _.get(parentSupply, 'item_id'),
  parent_supply_id: _.get(parentSupply, 'id'),
});

const extractBundleAndSaveBulkClaim = (parentSupply, actions, extra)  => ({
  parent_item_id: _.get(parentSupply, 'item_id'),
  parent_supply_id: _.get(parentSupply, 'id'),
  num_supplies: _.size(actions),
  supplies: _.map(actions, 'supply_id'),
  ...extra
})

const extractBundleAndSaveClose = (supply, start, end, extra) => {
  const differences = {
    secondsSpent: (_.get(end, 'time', 0) - _.get(start, 'time', 0)) / 1000,
    cashBackDifference: (_.get(end, 'cashBack', 0) - _.get(start, 'cashBack', 0)) / 100,
  };

  return extractBundleAndSaveDetails(supply, { ...differences, ...extra });
};

const analyticsActions = [{
  type: analyticsTypes.BUNDLE_INCENTIVE_SHOW,
  attributesExtractor: extractBundleAndSaveDetails,
}, {
  type: analyticsTypes.BUNDLE_INCENTIVE_CLAIM,
  attributesExtractor: extractBundleAndSaveClaim,
}, {
  type: analyticsTypes.BUNDLE_INCENTIVE_CLOSE,
  attributesExtractor: extractBundleAndSaveClose,
}, {
  type: analyticsTypes.BUNDLE_INCENTIVE_BULK_ADD,
  attributesExtractor: extractBundleAndSaveBulkClaim
}];

export {
  analyticsTypes,
  analyticsActions,
};
